import i18n from '../lib/i18n';
import { useStore } from '../lib/store';
import { getLanguageFromI18 } from '../config/languages';

let initialized = false;

/**
 * One-time setup that bridges i18n's `languageChanged` event into the store's
 * `selectedCountry` field. Module-level so the listener survives any
 * component lifecycle. Idempotent — safe to call from multiple places.
 *
 * Call once from main.tsx at app boot. The compatibility shim
 * {@link useSyncCountryWithLanguage} also calls this so existing
 * component-tree callsites keep working without churn.
 */
export function setupLocaleSync(): void {
  if (initialized) return;
  initialized = true;
  const syncFromLanguage = (lng: string) => {
    const currentCountry = useStore.getState().selectedCountry;
    const expectedCountry = getLanguageFromI18(lng);
    if (currentCountry.language !== expectedCountry.language) {
      useStore.setState({ selectedCountry: expectedCountry });
    }
  };
  // Apply the current language immediately so a persisted non-default
  // language at boot doesn't leave the store on the default until the user
  // toggles for the first time.
  syncFromLanguage(i18n.language);
  i18n.on('languageChanged', syncFromLanguage);
}

/**
 * @deprecated Call {@link setupLocaleSync} once from main.tsx instead. This
 * shim now no-ops after the first invocation so existing component-tree
 * callers keep working during the transition.
 */
export function useSyncCountryWithLanguage(): void {
  setupLocaleSync();
}
